import * as React from 'react';
import { IItemProps } from './carousel-item';

interface ICarouselContext {
    addItem: (props: IItemProps) => void;
    removeItem: (key: React.Key) => void;
}

export const CarouselContext = React.createContext<ICarouselContext>({
    addItem: () => { /** Fallback method */ },
    removeItem: () => { /** Fallback method */ }
});
